/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BuildingBlocksWrapper = ({ className, thumbnailClassName, thumbnail = "/img/thumbnail-70.png" }) => {
  return (
    <div className={`building-blocks-wrapper ${className}`}>
      <img className={`thumbnail ${thumbnailClassName}`} alt="Thumbnail" src={thumbnail} />
    </div>
  );
};

BuildingBlocksWrapper.propTypes = {
  thumbnail: PropTypes.string,
};
